// extracted by mini-css-extract-plugin
export default {"gym-name":"GymSelector_gym-name__1jTOt","multi":"GymSelector_multi__9ApyC","space-selector":"GymSelector_space-selector__-BKrB"};